import PropTypes from 'prop-types';
import React from 'react';
import _result from 'lodash/result';

import config from '../../config';
import Search from '../../records/SeasonSearch';
import Smartcard from '../../records/customer/Smartcard';
import { translate as t } from '../../lib/I18n';
import trainTime from '../../lib/TrainTime';

import Icon from '../general/Icon';
import DateSummary from '../form/DateSummary';
import TodayTomorrowControls from '../search/dates/TodayTomorrowControls';

class SeasonStartSummary extends React.PureComponent {

    static propTypes = {
        search: PropTypes.instanceOf(Search).isRequired,
        onChange: PropTypes.func.isRequired,
        smartcard: PropTypes.instanceOf(Smartcard),
        error: PropTypes.string
    };

    static defaultProps = {
        smartcard: null,
        error: ''
    };

    _handleDateSelect = (date) => {
        const { search, onChange } = this.props;
        const convertedDate = trainTime(date.format('YYYY-MM-DD'));
        onChange(search.setStartDate(convertedDate));
    };

    _renderScreenReadableStartDate () {
        const startDate = this.props.search.dates.getStartDate();
        if (startDate) {
            return (
                <span className="datetime__selected-date pull-left">
                    <time className="clearfix" dateTime={ startDate && startDate.format() }>
                        <span className="text-light datetime__fixed-width pull-left">
                            { t('season.summary.text') }
                        </span>
                    </time>
                    { <span aria-hidden="true">{ startDate.format('ddd') } </span> }
                    { startDate.format('DD MMM YYYY') }
                </span>
            );
        }
        return (
            <span className="datetime__selected-date pull-left">
                <time className="clearfix" dateTime={ startDate && startDate.format() }>
                    <span className="text-light datetime__fixed-width pull-left" aria-hidden="true">
                        { t('season.summary.text') }
                    </span>
                </time>
                { t('season.select.startDate') }
            </span>
        );
    }

    render () {
        const { search, smartcard, error } = this.props;

        const max = trainTime().add(trainTime.duration(
            (search.smartcard) ? config.get('maxSeasonStartPeriodSmartcard') : config.get('maxSeasonStartPeriod')
        ));
        const min = (search.smartcard && smartcard && smartcard.isAwaitingProduct()) ?
                trainTime().addWorkingDays(config.get('minAwaitingSmartcardProductDays')) : trainTime();
        const startDate = search.dates.getStartDate();

        const dateSummaryProps = {
            modalTitle: 'season.date.modal.title',
            onChange: this._handleDateSelect,
            selected: startDate,
            min: min,
            max: max,
            focused: !search.getValidationErrors().has('validateStationsComplete') && Boolean(error),
        };

        const disabledTodayTomorrow = _result(smartcard, 'isAwaitingProduct') && search.smartcard;

        return (
            <div>
                <TodayTomorrowControls
                    onChange={ this._handleDateSelect }
                    srOnly={ t('ariaLabel.setFieldDescription', { field: t('ariaLabel.startDateField') }) }
                    disabled={ disabledTodayTomorrow }/>
                <DateSummary { ...dateSummaryProps }>
                    <span className="sr-only">{ `${error}. ` } </span>
                    { this._renderScreenReadableStartDate() }
                    <Icon className="pull-right box__icon" icon="calendar" />
                </DateSummary>
            </div>
        );
    }

}

export default SeasonStartSummary;



// WEBPACK FOOTER //
// ./src/components/seasonTicket/SeasonStartSummary.js